// extracted by mini-css-extract-plugin
module.exports = {"btnDownloadAll":"btnDownloadAll--S-PQW"};